// extracted by mini-css-extract-plugin
export var label = "_7d-1";
export var reminder = "_7d-0";